require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./campus-durable-1-7.json") })
        }
      }, "path---campus-durable-1-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---campus-durable-1-7!./.cache/json/campus-durable-1-7.json
// module id = 359
// module chunks = 231608221292675